import {StoreConstants} from '../constants/store.constants';
import type {AnyPayloadAction, UserState} from '../models/store.models';
import {storeState} from '../models/store.models';

export function UserReducer(state: UserState = storeState.User, action: AnyPayloadAction): UserState {
  if (action.group !== StoreConstants.StoreGroups.User) return state;

  switch (action.type) {
    case StoreConstants.User.USER:
      return {
        ...state,
        user: action.user
      };

    case StoreConstants.User.USER$:
      return {
        ...state,
        user$: action.user$
      };

    case StoreConstants.User.USER_PHOTO:
      return {
        ...state,
        userPhoto: action.userPhoto
      };

    case StoreConstants.User.USER_PHOTO$:
      return {
        ...state,
        userPhoto$: action.userPhoto$
      };

    case StoreConstants.User.SESSION:
      return {
        ...state,
        session: action.session
      };

    case StoreConstants.User.SESSION$:
      return {
        ...state,
        session$: action.session$
      };

    case StoreConstants.User.ACTIVATION_PENDING$:
      return {
        ...state,
        activationPending$: action.activationPending$
      };

    case StoreConstants.User.SIGNED_IN$:
      return {
        ...state,
        signedIn$: action.signedIn$
      };

    default:
      return state;
  }
}
